import { firebase } from '../config/firebase.client';
import { userTypes } from '../types';


export interface ShareLocationData {
  usertype: 'driver' | 'customer';
  targetUid: string;
  createdAt: number;
  expiresAt: number;
  isActive: boolean;
}

export interface ActiveShare {
  id: string;
  shareLink: string;
  expiresAt: number;
  data: ShareLocationData;
}

export const checkActiveShare = async (userUid: string): Promise<ActiveShare[]> => {
  const data = await firebase.callFunction('sharedlocation-checkActiveShare', { userUid });
  return data.activeShares;
};

export const startLocationSharing = async (userUid: string, durationHours: number = 1, userType: userTypes): Promise<{ success: boolean; shareId?: string; shareLink?: string; expiresAt?: number; error?: string }> => {
  try {
    const result = await firebase.callFunction('sharedlocation-startLocationSharing', {
      userUid,
      durationHours,
      userType
    });

    return result;
  } catch (error: any) {
    console.error('Erro ao iniciar compartilhamento:', error);
    return { success: false, error: error.message };
  }
};

export const stopLocationSharing = async (
  shareId: string
): Promise<{ success: boolean; error?: string }> => {
  try {
    const result = await firebase.callFunction('sharedlocation-stopLocationSharing', { shareId });
    return result;
  } catch (error: any) {
    console.error('Erro ao parar compartilhamento:', error);
    return { success: false, error: error.message };
  }
};

export const formatTime = (milliseconds: number): string => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes.toString().padStart(2, '0')}m`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
  } else {
    return `${seconds}s`;
  }
};

export const getSharedLocation = async (shareId: string) => {
  try {
    const result = await firebase.callFunction('sharedlocation-getSharedLocation', { shareId });
    return result;
  } catch (error: any) {
    console.error('Erro ao obter localização compartilhada:', error);
    return { success: false, error: error.message };
  }
};

export interface LocationData {
  lat: number;
  lng: number;
}

export interface ShareLocationLiveResponse {
  success: boolean;
  data?: {
    shareInfo: ShareLocationData;
    location: LocationData | null;
  };
  error?: string;
}

export const getSharedLocationLive = async (shareId: string): Promise<ShareLocationLiveResponse> => {
  try {
    const result = await firebase.callFunction('sharedlocation-getSharedLocationLive', { shareId });
    return result;
  } catch (error: any) {
    console.error('Erro ao obter localização em tempo real:', error);
    return {
      success: false,
      error: error.message
    };
  }
};